/**
 * Created by 唐亦慧 on 2017/8/31.
 */
import Reflux from 'reflux';

export const specActions = Reflux.createActions([
	'paramChange',
	'useStoreChange'
]);

export class specStore extends Reflux.Store {
	constructor() {
		super();
		this.state = {
			storeData:{
				name:'',
				productTypeId:'',
				//active:null,
				s: 10,
				p: 1
			}
		}
		this.listenables = specActions;
	}
	
	useStoreChange(flag){
		this.setState({
			...this.state,
			useStore: flag
		});
	}
	paramChange(data){
		this.setState({
			...this.state,
			storeData:{
				...this.state.storeData,
				...data
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/routes/productSpec/store.js